(function () {
  const drawer = document.getElementById('CatalogDrawer');
  if (!drawer) return;

  const closeEls = drawer.querySelectorAll('[data-catalog-close]');
  const catBtns = drawer.querySelectorAll('[data-catalog-cat]');
  const subPanels = drawer.querySelectorAll('.catalogDrawer__subPanel');

  let lastActiveElement = null;

  function openDrawer() {
    lastActiveElement = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    const closeBtn = drawer.querySelector('[data-catalog-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastActiveElement) lastActiveElement.focus();
  }

  function activatePanel(targetId) {
    subPanels.forEach(p => {
      const isMatch = p.id === targetId;
      p.hidden = !isMatch;
      p.classList.toggle('is-active', isMatch);
    });

    catBtns.forEach(b => {
      const isActive = b.getAttribute('data-target') === targetId;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
 const a = e.target.closest('a[href*="#catalog"]');
if (!a) return;

    e.preventDefault();
    openDrawer();
  });

  closeEls.forEach(el => el.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  catBtns.forEach(btn => {
    const targetId = btn.getAttribute('data-target');
    btn.addEventListener('mouseenter', () => activatePanel(targetId));
    btn.addEventListener('focus', () => activatePanel(targetId));
    btn.addEventListener('click', () => activatePanel(targetId));
  });
})();
